const onlyPlaca = value => /[A-Za-z]{1,3}|[A-Za-z]{1,3}\d|[A-Za-z]{1,3}\d\w|[A-Za-z]{1,3}\d\w\d\d/g.test(value.replace('-', '')) || value === '';

export default onlyPlaca;
